/* Moody Cow Studio — theme.js
   No dependencies. Everything here is an enhancement: with JavaScript off the
   site still browses, filters (via links), and checks out. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mobile drawer ---------- */
  var burger = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  if (burger && drawer) {
    var header = document.querySelector('.hdr');
    var announce = document.querySelector('.announce');
    var setDrawer = function (open) {
      drawer.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? burger.dataset.close : burger.dataset.open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        // Sit the drawer under the announcement bar + header so both stay visible.
        window.scrollTo({ top: 0 });
        var offset = (announce ? announce.offsetHeight : 0) + (header ? header.offsetHeight : 0);
        if (offset > 0) {
          drawer.style.top = offset + 'px';
          drawer.style.paddingTop = '24px';
        }
      } else {
        drawer.style.top = '';
        drawer.style.paddingTop = '';
      }
    };
    burger.addEventListener('click', function () {
      setDrawer(!drawer.classList.contains('open'));
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') setDrawer(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) setDrawer(false);
    });
  }

  /* ---------- desktop mega menu ---------- */
  var megaWrap = document.querySelector('[data-mega]');
  if (megaWrap) {
    var megaBtn = megaWrap.querySelector('button');
    var setMega = function (open) {
      megaWrap.classList.toggle('open', open);
      if (megaBtn) megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    megaWrap.addEventListener('mouseenter', function () { setMega(true); });
    megaWrap.addEventListener('mouseleave', function () { setMega(false); });
    if (megaBtn) {
      megaBtn.addEventListener('click', function () {
        setMega(!megaWrap.classList.contains('open'));
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMega(false);
    });
    megaWrap.addEventListener('focusout', function (e) {
      if (!megaWrap.contains(e.relatedTarget)) setMega(false);
    });
  }

  /* ---------- shop section tabs ----------
     Every tab's grid is rendered by Liquid; we only show/hide. */
  var tabsWrap = document.querySelector('[data-tabs]');
  if (tabsWrap) {
    var panels = document.querySelectorAll('[data-tab-panel]');
    var viewAll = document.querySelector('[data-tabs-viewall]');
    tabsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-tab]');
      if (!btn) return;
      var id = btn.dataset.tab;
      tabsWrap.querySelectorAll('button[data-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var active = p.dataset.tabPanel === id;
        if (active) {
          p.hidden = false;
          p.classList.add('swap');
          requestAnimationFrame(function () { p.classList.remove('swap'); });
        } else {
          p.hidden = true;
        }
      });
      if (viewAll && btn.dataset.url) {
        viewAll.href = btn.dataset.url;
        viewAll.innerHTML = btn.dataset.viewall + ' <span aria-hidden="true">&rarr;</span>';
      }
    });
  }

  /* ---------- statement: light the words as it scrolls past ---------- */
  var statement = document.querySelector('[data-statement]');
  if (statement) {
    var text = statement.textContent.trim();
    statement.innerHTML = text.split(/\s+/).map(function (w) {
      return '<span class="w">' + w + '</span>';
    }).join(' ');
    var words = [].slice.call(statement.querySelectorAll('.w'));
    if (reduceMotion) {
      words.forEach(function (w) { w.classList.add('lit'); });
    } else {
      var light = function () {
        var r = statement.getBoundingClientRect();
        var progress = (window.innerHeight * 0.85 - r.top) / (r.height + window.innerHeight * 0.35);
        progress = Math.min(1, Math.max(0, progress));
        var n = Math.round(progress * words.length);
        words.forEach(function (w, i) { w.classList.toggle('lit', i < n); });
      };
      window.addEventListener('scroll', light, { passive: true });
      window.addEventListener('resize', light);
      light();
    }
  }

  /* ---------- reviews carousel ---------- */
  var stage = document.querySelector('[data-reviews]');
  if (stage) {
    var slides = stage.querySelectorAll('.rev');
    var dots = document.querySelectorAll('[data-review-dot]');
    var timer;
    var show = function (i) {
      slides.forEach(function (s, j) { s.classList.toggle('on', j === i); });
      dots.forEach(function (d, j) {
        d.classList.toggle('on', j === i);
        d.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
      clearTimeout(timer);
      if (slides.length > 1 && !reduceMotion) {
        timer = setTimeout(function () { show((i + 1) % slides.length); }, 5500);
      }
    };
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.reviewDot, 10)); });
    });
    if (slides.length) show(0);
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var min = parseInt(input.min || '1', 10);
        var next = (parseInt(input.value, 10) || min) + (btn.dataset.step === 'down' ? -1 : 1);
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* cart line quantities submit the cart form on change */
  document.querySelectorAll('[data-cart-qty] input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- product page ---------- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var dataEl = document.querySelector('[data-product-json]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var buyBtn = form.querySelector('[data-buy]');
    var buyPrice = form.querySelector('[data-buy-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var mainImg = document.querySelector('[data-main-image]');
    var moneyEl = document.querySelector('[data-money-format]');
    var moneyFormat = moneyEl ? moneyEl.dataset.moneyFormat : '£{{amount}}';

    var money = function (cents) {
      // Keep the pence so JS prices read the same as the ones Shopify renders.
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    var selected = function () {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts[parseInt(fs.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      return opts;
    };

    var optionGroups = form.querySelectorAll('[data-option-index]');

    var update = function () {
      var variant;
      if (!optionGroups.length) {
        // Products with a single variant have no pickers to read.
        variant = variants.filter(function (v) {
          return String(v.id) === String(idInput && idInput.value);
        })[0] || variants[0];
      } else {
        var opts = selected();
        variant = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        })[0];
      }

      // reflect the chosen value next to each option label
      form.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-option-value]');
        if (label && checked) label.textContent = checked.dataset.label || checked.value;
      });

      if (!variant) {
        if (buyBtn) {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.dataset.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.textContent = onSale ? money(variant.compare_at_price) : '';
        compareEl.hidden = !onSale;
      }

      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var total = variant.price * qty;

      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.innerHTML = variant.available
          ? buyBtn.dataset.add + ' · <span data-buy-price>' + money(total) + '</span>'
          : buyBtn.dataset.soldout;
        buyPrice = form.querySelector('[data-buy-price]');
      }
      if (stickyPrice) stickyPrice.textContent = money(variant.price) + ' · ' + variant.title;

      if (variant.featured_media && mainImg && variant.featured_media.preview_image) {
        mainImg.src = variant.featured_media.preview_image.src;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    form.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    if (qtyInput) qtyInput.addEventListener('change', update);
    update();

    /* gallery thumbnails */
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.src;
        if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
        document.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });

    /* sticky buy bar on phones, once the real button scrolls away */
    var sticky = document.querySelector('[data-sticky-buy]');
    if (sticky && buyBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('on', !entries[0].isIntersecting);
      }).observe(buyBtn);
    }
  }

  /* ---------- collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
